(function () {
  'use strict';

  if (!location.pathname.includes('/products/viaim-nano-ai-recording-earbuds')) return;

  var data = {
    'Shiny Black': {
      base: {
        free: ['50519398514934', 149.99, 149.99, 'https://cdn.shopify.com/s/files/1/0722/7647/6150/files/Nano_ShinyBlack_4K_01.jpg?v=1776846000'],
        pro: ['51547850735862', 199.99, 229.98, 'https://cdn.shopify.com/s/files/1/0722/7647/6150/files/nano_-pro-black_e1169e75-d75f-4ed8-b649-bfea50da5911.png?v=1780985354'],
        ultra: ['51547850768630', 259.99, 309.98, 'https://cdn.shopify.com/s/files/1/0722/7647/6150/files/nano_-ultra-black_c1f27b81-fb09-4cb4-9286-817c610eb0b0.png?v=1780985506']
      },
      noteKit: {
        free: ['50520526815478', 199.99, 239.98, 'https://cdn.shopify.com/s/files/1/0722/7647/6150/files/nano_notekit.jpg?v=1776934248'],
        pro: ['51547891958006', 239.99, 319.97, 'https://cdn.shopify.com/s/files/1/0722/7647/6150/files/nano_probundle.png?v=1781320909'],
        ultra: ['51547850834166', 299.99, 399.97, 'https://cdn.shopify.com/s/files/1/0722/7647/6150/files/nano_superbundle.png?v=1781321173']
      }
    },
    'Shadow Green': {
      base: {
        free: ['50519398547702', 149.99, 149.99, 'https://cdn.shopify.com/s/files/1/0722/7647/6150/files/nano_green1.jpg?v=1776846000'],
        pro: ['51547850866934', 199.99, 229.98, 'https://cdn.shopify.com/s/files/1/0722/7647/6150/files/nano_-pro-green_7391b5bd-97ef-4201-a5fa-1e96e404379a.png?v=1780985354'],
        ultra: ['51547850899702', 259.99, 309.98, 'https://cdn.shopify.com/s/files/1/0722/7647/6150/files/nano_-ultra-green_6c7ba4c8-8418-4e17-9cd3-4af22958ea54.png?v=1780985506']
      },
      noteKit: {
        free: ['50520526848246', 199.99, 239.98, 'https://cdn.shopify.com/s/files/1/0722/7647/6150/files/nano_notekit_1_450a811d-873e-4cb6-bb44-d55035a5dc60.jpg?v=1776934269'],
        pro: ['51547891990774', 239.99, 319.97, 'https://cdn.shopify.com/s/files/1/0722/7647/6150/files/nano_probundle-2.png?v=1781320909'],
        ultra: ['51547850965238', 299.99, 399.97, 'https://cdn.shopify.com/s/files/1/0722/7647/6150/files/nano_ultrabundle-3.png?v=1781321233']
      }
    }
  };

  var legacy = {
    '50519398514934': ['Shiny Black', false, 'free'],
    '50520526815478': ['Shiny Black', true, 'free'],
    '51547850735862': ['Shiny Black', false, 'pro'],
    '51547850768630': ['Shiny Black', false, 'ultra'],
    '51547891958006': ['Shiny Black', true, 'pro'],
    '51547850834166': ['Shiny Black', true, 'ultra'],
    '50519398547702': ['Shadow Green', false, 'free'],
    '50520526848246': ['Shadow Green', true, 'free'],
    '51547850866934': ['Shadow Green', false, 'pro'],
    '51547850899702': ['Shadow Green', false, 'ultra'],
    '51547891990774': ['Shadow Green', true, 'pro'],
    '51547850965238': ['Shadow Green', true, 'ultra']
  };

  var colors = ['Shiny Black', 'Shadow Green'];
  var selections = [
    'Nano+',
    'Nano+ & Notekit',
    'Nano + & Annual Pro',
    'Nano+ & Annual Ultra',
    'Nano+ & Notekit + Annual Pro',
    'Nano+ & Notekit + Annual Ultra'
  ];
  var root;
  var state = stateFromVariant(new URLSearchParams(location.search).get('variant')) || {
    color: 'Shiny Black',
    noteKit: false,
    plan: null
  };

  function money(value) {
    return '$' + Number(value).toFixed(2);
  }

  function compactMoney(value) {
    var rounded = Math.round(Number(value) * 100) / 100;
    return '$' + (rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(2));
  }

  function selection() {
    return data[state.color][state.noteKit ? 'noteKit' : 'base'][state.plan || 'free'];
  }

  function planName() {
    if (state.plan === 'pro') return 'Annual Pro';
    if (state.plan === 'ultra') return 'Annual Ultra';
    return 'Free';
  }

  function stateFromVariant(id) {
    if (!id || !legacy[id]) return null;
    return {
      color: legacy[id][0],
      noteKit: legacy[id][1],
      plan: legacy[id][2]
    };
  }

  function setId(id) {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var input = form.querySelector('[name="id"]');
      if (input) {
        input.value = id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function updateUrl(id) {
    var url = new URL(location.href);
    url.searchParams.set('variant', id);
    history.replaceState({}, '', url);
  }

  function updateImage(item) {
    if (!item || !item[3]) return;
    var src = item[3];
    var img = document.querySelector('.product-gallery img, product-gallery img, media-gallery img, .product__media img');
    if (!img) return;
    img.src = src;
    img.srcset = '';
    img.alt = 'viaim Nano+ ' + state.color + ' ' + planName();
  }

  function save(item) {
    return Math.max(0, Number(item[2]) - Number(item[1]));
  }

  function updatePlanCards() {
    if (!root) return;
    var kitKey = state.noteKit ? 'noteKit' : 'base';
    var freeItem = data[state.color][kitKey].free;

    ['pro', 'ultra'].forEach(function (plan) {
      var planItem = data[state.color][kitKey][plan];
      var price = root.querySelector('[data-plan-price="' + plan + '"]');
      var saving = root.querySelector('[data-plan-saving="' + plan + '"]');
      if (price) price.textContent = '+' + compactMoney(Number(planItem[1]) - Number(freeItem[1])) + '/year';
      if (saving) saving.textContent = 'Save ' + money(save(planItem));
    });
  }

  function hideNative() {
    var labels = document.querySelectorAll('legend, .form__label, label, .product-form__option-name');
    labels.forEach(function (label) {
      var group = label.closest('fieldset, .product-form__input, .product-info__variant-picker, variant-picker, .selector-wrapper');
      if (!group || group.classList.contains('viaim-flow')) return;
      var text = group.textContent || '';
      var hidesColor = colors.some(function (value) { return text.includes(value); });
      var hidesSelection = selections.some(function (value) { return text.includes(value); });
      if (hidesColor || hidesSelection) group.classList.add('viaim-hidden-selection');
    });
  }

  function insertStyles() {
    if (document.getElementById('viaim-nano-flow-style')) return;
    var style = document.createElement('style');
    style.id = 'viaim-nano-flow-style';
    style.textContent = [
      '.viaim-hidden-selection{display:none!important}',
      '.viaim-nano-flow{margin:22px 0 18px;font-family:inherit;color:rgb(var(--color-foreground,29 29 31))}',
      '.viaim-nano-flow *{box-sizing:border-box}',
      '.viaim-nano-flow .vrs{padding:22px 0;border-top:1px solid rgba(var(--color-foreground,29 29 31),.13)}',
      '.viaim-nano-flow .vrs:first-child{border-top:0;padding-top:0}',
      '.viaim-nano-flow h3{font-size:21px;line-height:1.2;margin:0 0 14px;font-weight:500;letter-spacing:0}',
      '.viaim-nano-flow .hint{margin:-6px 0 14px;color:rgba(var(--color-foreground,29 29 31),.68);font-size:14px;line-height:1.42}',
      '.viaim-nano-flow .grid{display:grid;gap:12px}',
      '.viaim-nano-flow .grid.two{grid-template-columns:repeat(2,minmax(0,1fr))}',
      '.viaim-nano-flow .vrc{appearance:none;width:100%;min-height:72px;border:1px solid #6e6e73;border-radius:13px;background:rgb(var(--color-background,255 255 255));text-align:left;padding:15px 18px;color:inherit;display:flex;align-items:center;justify-content:space-between;gap:14px;cursor:pointer;transition:border-color .16s ease,background .16s ease}',
      '.viaim-nano-flow .vrc:hover{border-color:#f55f0c}',
      '.viaim-nano-flow .vrc[aria-pressed="true"]{border-color:#f55f0c;background:linear-gradient(135deg,#fff 0%,rgba(245,95,12,.06) 100%)}',
      '.viaim-nano-flow .vrc.color{min-height:58px}',
      '.viaim-nano-flow .left{min-width:0}',
      '.viaim-nano-flow .main{display:block;font-size:17px;line-height:1.22;font-weight:750;letter-spacing:0}',
      '.viaim-nano-flow .vrc.color .main{font-size:16px;font-weight:400}',
      '.viaim-nano-flow .sub{display:block;font-size:13.5px;line-height:1.4;color:rgba(var(--color-foreground,29 29 31),.72);margin-top:4px}',
      '.viaim-nano-flow .price{font-size:15px;font-weight:800;color:#f55f0c;white-space:nowrap}',
      '.viaim-nano-flow .tag{display:inline-block;margin-top:8px;padding:4px 9px;border-radius:999px;background:rgba(245,95,12,.08);color:#d84f05;font-weight:650;font-size:12px;line-height:1}',
      '.viaim-nano-flow .dot{width:16px;height:16px;border-radius:999px;display:inline-block;border:1px solid rgba(var(--color-foreground,29 29 31),.18);box-shadow:inset 0 0 0 2px #fff;margin-right:10px;flex:0 0 16px}',
      '.viaim-nano-flow .dot.black{background:#050505}',
      '.viaim-nano-flow .dot.green{background:linear-gradient(135deg,#344233,#87927e)}',
      '.viaim-nano-flow .color-label{display:flex;align-items:center}',
      '.viaim-nano-flow .plan-grid .vrc{min-height:72px}',
      '.viaim-nano-flow .summary{display:none;margin-top:18px;border-radius:18px;background:#f5f5f7;padding:18px 20px;font-size:14px;color:rgb(var(--color-foreground,29 29 31));line-height:1.42;align-items:center;justify-content:space-between;gap:14px}',
      '.viaim-nano-flow .summary.ready{display:flex}',
      '.viaim-nano-flow .summary small{display:block;margin-bottom:4px;font-size:12px;font-weight:750;color:#d84f05}',
      '.viaim-nano-flow .summary strong{display:block;color:rgb(var(--color-foreground,29 29 31));font-size:17px;line-height:1.22;font-weight:750;margin-bottom:4px}',
      '.viaim-nano-flow .summary .sum-price{display:flex;flex-direction:column;align-items:flex-end;gap:2px;white-space:nowrap}',
      '.viaim-nano-flow .summary .was{font-size:14px;color:rgba(var(--color-foreground,29 29 31),.48);text-decoration:line-through}',
      '.viaim-nano-flow .summary .now{font-size:20px;font-weight:800;color:#f55f0c}',
      '.viaim-feature-fold{position:relative}',
      '.viaim-feature-fold.is-collapsed .viaim-feature-preview{display:block;max-height:34px;overflow:hidden;opacity:.28;position:relative}',
      '.viaim-feature-fold.is-collapsed .viaim-feature-preview:after{content:"";position:absolute;inset:auto 0 0 0;height:24px;background:linear-gradient(180deg,rgba(var(--color-background,255 255 255),0),rgb(var(--color-background,255 255 255)))}',
      '.viaim-feature-fold.is-collapsed .viaim-feature-hidden{display:none}',
      '.viaim-feature-fold:not(.is-collapsed) .viaim-feature-preview{opacity:1;max-height:none}',
      '.viaim-feature-fold:not(.is-collapsed) .viaim-feature-hidden{display:block}',
      '.viaim-feature-toggle{appearance:none;background:transparent;border:0;color:rgb(var(--color-foreground,29 29 31));cursor:pointer;display:flex;align-items:center;gap:8px;font:inherit;font-size:14px;line-height:1.2;margin:8px 0 0 auto;padding:8px 0;text-decoration:underline;text-underline-offset:3px}',
      '.viaim-feature-toggle .chev{width:8px;height:8px;border-right:1.5px solid currentColor;border-bottom:1.5px solid currentColor;transform:rotate(45deg);margin-top:-4px;transition:transform .2s ease}',
      '.viaim-feature-toggle[aria-expanded="true"] .chev{transform:rotate(225deg);margin-top:4px}',
      '@media (max-width:749px){.viaim-nano-flow .grid.two{grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}.viaim-nano-flow .vrc{padding:15px}.viaim-nano-flow .vrc.color{min-height:54px;padding:13px 12px}.viaim-nano-flow .vrc.color .main{font-size:15px}.viaim-nano-flow .dot{margin-right:8px}.viaim-nano-flow .summary.ready{align-items:flex-start;flex-direction:column;padding:16px}.viaim-nano-flow .summary .sum-price{align-items:flex-start}.viaim-feature-toggle{font-size:14px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function findFeatureBlock() {
    var candidates = document.querySelectorAll('.product-info__description, .product__description, [data-block-type="description"], .rte');
    for (var i = 0; i < candidates.length; i += 1) {
      var text = candidates[i].textContent || '';
      if (text.includes('FlashRecord:') && text.includes('Real-Time Translation:') && text.includes('Start Free:')) {
        return candidates[i];
      }
    }
    return null;
  }

  function enhanceFeatures() {
    var block = findFeatureBlock();
    if (!block || block.dataset.viaimFolded) return;
    var paragraphs = block.querySelectorAll('p');
    if (paragraphs.length < 4) return;
    block.dataset.viaimFolded = 'true';
    block.classList.add('viaim-feature-fold', 'is-collapsed');
    paragraphs.forEach(function (paragraph, index) {
      if (index === 3) paragraph.classList.add('viaim-feature-preview');
      if (index > 3) paragraph.classList.add('viaim-feature-hidden');
    });

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'viaim-feature-toggle';
    button.setAttribute('aria-expanded', 'false');
    button.innerHTML = '<span>View More</span><i class="chev" aria-hidden="true"></i>';
    button.addEventListener('click', function () {
      var expanded = block.classList.toggle('is-expanded');
      block.classList.toggle('is-collapsed', !expanded);
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.querySelector('span').textContent = expanded ? 'View Less' : 'View More';
    });

    block.insertAdjacentElement('afterend', button);
  }

  function placeFeaturesAboveFlow() {
    if (!root || !root.parentNode) return;
    var block = document.querySelector('.viaim-feature-fold');
    var button = document.querySelector('.viaim-feature-toggle');
    if (!block || (block.nextElementSibling === button && button.nextElementSibling === root)) return;
    root.parentNode.insertBefore(block, root);
    if (button) root.parentNode.insertBefore(button, root);
  }

  function mountPoint() {
    return document.querySelector('variant-picker, .product-info__variant-picker, .product-form__input, form[action*="/cart/add"]');
  }

  function render() {
    if (root && document.body.contains(root)) return;
    var target = mountPoint();
    if (!target) return;

    root = document.createElement('div');
    root.className = 'viaim-flow viaim-nano-flow';
    root.innerHTML =
      '<section class="vrs">' +
        '<h3>Choose your color</h3>' +
        '<div class="grid two">' +
          '<button class="vrc color" type="button" data-color="Shiny Black"><span class="main color-label"><i class="dot black"></i>Shiny Black</span></button>' +
          '<button class="vrc color" type="button" data-color="Shadow Green"><span class="main color-label"><i class="dot green"></i>Shadow Green</span></button>' +
        '</div>' +
      '</section>' +
      '<section class="vrs">' +
        '<h3>Add NoteKit to your setup?</h3>' +
        '<div class="grid">' +
          '<button class="vrc" type="button" data-kit="base"><span class="left"><span class="main">Nano+ only</span></span><span class="price" data-kit-base-price></span></button>' +
          '<button class="vrc" type="button" data-kit="noteKit"><span class="left"><span class="main">Nano+ + NoteKit</span><span class="sub">A USB AI meeting recorder for your computer.</span><span class="tag" data-kit-saving></span></span><span class="price" data-kit-total></span></button>' +
        '</div>' +
      '</section>' +
      '<section class="vrs">' +
        '<h3>Choose your AI plan</h3>' +
        '<p class="hint">600 min/month included. Add an annual plan when you need more.</p>' +
        '<div class="grid plan-grid">' +
          '<button class="vrc" type="button" data-plan="free"><span class="left"><span class="main">Free Plan</span><span class="sub">600 transcription minutes/month included.</span></span><span class="price">Included</span></button>' +
          '<button class="vrc" type="button" data-plan="pro"><span class="left"><span class="main">Annual Pro</span><span class="sub">1,800 min/month. Best for frequent meetings.</span><span class="tag" data-plan-saving="pro"></span></span><span class="price" data-plan-price="pro"></span></button>' +
          '<button class="vrc" type="button" data-plan="ultra"><span class="left"><span class="main">Annual Ultra</span><span class="sub">Unlimited transcription. Best for heavy daily use.</span><span class="tag" data-plan-saving="ultra"></span></span><span class="price" data-plan-price="ultra"></span></button>' +
        '</div>' +
        '<div class="summary" aria-live="polite"><span><small>Your selection</small><strong data-summary-title></strong><span data-summary-text></span></span><span class="sum-price" data-total><span class="was" data-was></span><span class="now" data-now></span></span></div>' +
      '</section>';

    target.parentNode.insertBefore(root, target);
    bind();
    paint();
    placeFeaturesAboveFlow();
  }

  function bind() {
    root.addEventListener('click', function (event) {
      var button = event.target.closest('button');
      if (!button) return;
      if (button.dataset.color) state.color = button.dataset.color;
      if (button.dataset.kit) state.noteKit = button.dataset.kit === 'noteKit';
      if (button.dataset.plan) state.plan = button.dataset.plan;
      paint();
    });

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.viaimNanoBound) return;
      form.dataset.viaimNanoBound = 'true';
      form.addEventListener('submit', function (event) {
        if (!state.plan) {
          event.preventDefault();
          event.stopPropagation();
          var first = root.querySelector('[data-plan]');
          if (first) first.focus();
          setAddButton('Choose AI plan');
        }
      }, true);
    });
  }

  function setAddButton(text) {
    document.querySelectorAll('form[action*="/cart/add"] button[type="submit"], product-form button[type="submit"]').forEach(function (button) {
      if (!button.dataset.viaimOriginalText) button.dataset.viaimOriginalText = button.textContent.trim();
      var label = button.querySelector('span') || button;
      label.textContent = text;
    });
  }

  function paint() {
    if (!root) return;
    root.querySelectorAll('[data-color]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.dataset.color === state.color ? 'true' : 'false');
    });
    root.querySelectorAll('[data-kit]').forEach(function (button) {
      button.setAttribute('aria-pressed', (button.dataset.kit === 'noteKit') === state.noteKit ? 'true' : 'false');
    });
    root.querySelectorAll('[data-plan]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.dataset.plan === state.plan ? 'true' : 'false');
    });

    var baseItem = data[state.color].base[state.plan || 'free'];
    var kitItem = data[state.color].noteKit[state.plan || 'free'];
    var item = selection();
    var delta = Math.max(0, kitItem[1] - baseItem[1]);
    var kitSave = save(kitItem);
    var kitBase = root.querySelector('[data-kit-base-price]');
    var kitTotal = root.querySelector('[data-kit-total]');
    var kitSaving = root.querySelector('[data-kit-saving]');
    var summary = root.querySelector('.summary');
    var title = root.querySelector('[data-summary-title]');
    var text = root.querySelector('[data-summary-text]');
    var was = root.querySelector('[data-was]');
    var now = root.querySelector('[data-now]');

    if (kitBase) kitBase.textContent = money(baseItem[1]);
    if (kitTotal) kitTotal.textContent = money(kitItem[1]);
    if (kitSaving) kitSaving.textContent = 'Save ' + money(kitSave) + (delta > 0 ? ' vs separate purchase' : '');
    updatePlanCards();
    if (summary) summary.classList.toggle('ready', Boolean(state.plan));
    if (title) title.textContent = (state.noteKit ? 'Nano+ + NoteKit' : 'Nano+') + ' / ' + state.color + ' / ' + planName();
    if (text) text.textContent = 'Save ' + money(save(item));
    if (was) was.textContent = money(item[2]);
    if (now) now.textContent = money(item[1]);

    setId(item[0]);
    updateUrl(item[0]);
    updateImage(item);
    setAddButton(state.plan ? 'Add to cart' : 'Choose AI plan');
  }

  function init() {
    insertStyles();
    enhanceFeatures();
    hideNative();
    render();
    placeFeaturesAboveFlow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  new MutationObserver(function () {
    hideNative();
    render();
    placeFeaturesAboveFlow();
  }).observe(document.documentElement, { childList: true, subtree: true });
}());
